// extracted by mini-css-extract-plugin
module.exports = {"root":"ContentDocsPermit_root__yvmjV","upload":"ContentDocsPermit_upload__2Tudw","btn":"ContentDocsPermit_btn__3V_AB"};